/*
 * Copyright (c) 2023 - 2026 Bluemate B.V.
 */

// Injected at build time by vite.config.ts `define`: build-time env override
// (VAPID_PUBLIC_KEY / VITE_VAPID_PUBLIC_KEY) or the per-mode default baked in
// there. The service worker bundle receives the same value (see src/sw.ts).
declare const __VAPID_PUBLIC_KEY__: string;

window.allowCookies = true;
const env = import.meta.env;
const windowSettings = window.settings ?? {};
window.settings = {
    tinyApiKey: env.VITE_TINY_API_KEY,
    bolOauthClientId: env.VITE_BOL_OAUTH_CLIENT_ID,
    bolOauthInsightsClientId: env.VITE_BOL_OAUTH_INSIGHTS_CLIENT_ID,
    hideProductSyncForUsers: env.VITE_HIDE_PRODUCT_SYNC_FOR_USERS?.split(',') ?? [],
    mode: env.VITE_APP_MODE ?? 'prod',
    platformUrl: env.VITE_PLATFORM_URL,
    filePrefix: env.VITE_FILE_PREFIX,
    allowExperimental: env.VITE_ALLOW_EXPERIMENTAL === 'true',
    stripeApiKey: env.VITE_STRIPE_PUBLIC_KEY,
    appUrl: env.VITE_APP_URL,
    showDevUpdates: env.VITE_SHOW_DEV_UPDATES ?? 'regular',
    gaID: env.VITE_GA_ID,
    sendToGaID: env.VITE_SEND_TO_GA_ID,
    oauthState: env.VITE_OAUTH_STATE,
    sentryUrl: env.VITE_SENTRY_URL,
    // --- Web push ---
    // Kill switch: set VITE_ENABLE_WEB_PUSH=false to hide all push UI in an
    // emergency without a backend redeploy.
    enableWebPush: env.VITE_ENABLE_WEB_PUSH !== 'false',
    // VAPID public key for the browser push subscription. Generated by backend
    // external_scripts/generate_vapid.py; the matching private key + subject
    // live in the per-env backend config.ini — do NOT commit them.
    vapidPublicKey: __VAPID_PUBLIC_KEY__,
    ...windowSettings
};
